import { RichTextDefaultArr } from '@/constants';

export const hasNonEmptyRichTextField = (value: string | undefined): value is string =>
	!!(value && !RichTextDefaultArr.includes(value.trim()));
